import React from 'react'

export const RoundedImage = ({imageUrl}) => {
  return (
    <div className="w-10 h-10 rounded-full p-0.5 bg-amber-200 animate-pulse">
        <img className='w-full h-full rounded-full' src={imageUrl} alt="bg" />
    </div>
  )
}


